import React from 'react';
import { Link } from 'react-router-dom';
import { Button, Form } from 'semantic-ui-react';

const CreatePermissionSetForm = (props) => {
  return (
    <Form>
      <Form.Input label="Name" placeholder="Permission Set Name" required />
      <Button primary>Create</Button>
      <Button as={Link} to="/o/permission-sets">Cancel</Button>
    </Form>
  );
};

export default CreatePermissionSetForm;
